/* Artwork is referenced by URL, never inlined: a base64 blob cannot be written
   through the Magic Patterns API. Paste hosted URLs into BONUS_COVERS in
   links.ts. While they are empty every card falls back to a typeset panel in
   the brand colours, which is a finished look, not a placeholder. */
import { BONUS_COVERS } from './links'

export const BONUS_IMAGES: Record<string, string> = BONUS_COVERS
